import React from "react";
import CatalogoPageLayout from "./CatalogoPageLayout";

const CatalogoMesasPage: React.FC = () => (
  <CatalogoPageLayout
    title="Mesas y salones"
    description="Configurá la distribución de mesas, sectores y asignaciones para el servicio en salón."
    helperText="Muy pronto vas a poder definir mapas de mesa, capacidades y propinas sugeridas."
  />
);

export default CatalogoMesasPage;
